import { event } from '../content/event';

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div>
        <a className="wordmark wordmark--footer" href="#top"><span aria-hidden="true">🦃</span> BBABDT</a>
        <p>{event.edition} years of good friends, great food, and one big damn turkey.</p>
      </div>
      <a href="#top">Back to top ↑</a>
    </footer>
  );
}

export default SiteFooter;
